import React, { useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import { Layout, Col, Row, Select } from "antd";
import { Button, Card, Form, Spin, Input, DatePicker } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { CREATE_COUPON } from "../../constants/api";
import dayjs from 'dayjs';

function CouponAdd() {
  const { Content } = Layout;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = (start, end) => {
    const startDate = start ? start.startOf("day") : null;
    const endDate = end ? end.startOf("day") : null;
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const createData = (values) => {
    setIsLoading(true);
    const formattedCouponStart = dayjs(values.start_date).format("D-M-YYYY");
    const formattedCouponEnd = dayjs(values.end_date).format("D-M-YYYY");
    const data = new FormData();
    data.append("coupon_code", values.coupon_code);
    data.append("title", values.title);
    data.append("description", values.description);
    data.append("coupon_value", values.coupon_value);
    data.append("coupon_value_type", values.coupon_value_type);
    data.append("coupon_start", formattedCouponStart);
    data.append("coupon_end", formattedCouponEnd);
    data.append("minimum_amount", values.minimum_amount);

    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/coupon");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_COUPON, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Create Coupon"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={createData}>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Title" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="coupon_code"
                      label="Coupon Code"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Coupon Code" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="coupon_value_type"
                      label="Coupon Value Type"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a Coupon Value Type"
                        optionFilterProp="label"
                        options={[
                          {
                            value: "percent",
                            label: "Percent",
                          },
                          {
                            value: "amount",
                            label: "Amount",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="coupon_value"
                      label="Coupon Value"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the Coupon Value",
                        },
                        {
                          pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                          message:
                            "Please enter a valid Coupon Value (e.g., 1000, 1000.50)",
                        },
                      ]}
                    >
                      <Input type="number" placeholder="Coupon Value" min={0} />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      name="start_date"
                      label="Start Date"
                      rules={[
                        {
                          required: true,
                          message: "Please select the start date",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        value={startDate}
                        onChange={(date) => handleDateChange(date, endDate)}
                        disabledDate={(current) =>
                          current && current < new Date().setHours(0, 0, 0, 0)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="end_date"
                      label="End Date"
                      rules={[
                        {
                          required: true,
                          message: "Please select the end date",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        value={endDate}
                        onChange={(date) => handleDateChange(startDate, date)}
                        disabledDate={(current) =>
                          current && current < startDate.startOf("day")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="minimum_amount"
                      label="Minimum Amount"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the Minimum Amount",
                        },
                        {
                          pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                          message:
                            "Please enter a valid Minimum Amount (e.g., 1000, 1000.50)",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="Minimum Amount"
                        min={0}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Description" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default CouponAdd;
